import api from '../../api'
import {
  GET_POLL_LIST_SUCCESS,
  GET_POLL_LIST_FAILURE,
  GET_POLL_FAILURE,
  GET_POLL_SUCCESS,
  UPDATE_POLL_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getPollList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getPollList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
         commit(GET_POLL_LIST_FAILURE)
         return reject(response.body.$error)

      }
      commit(GET_POLL_LIST_SUCCESS, {
        pollList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_POLL_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanPollList({commit}) {
    return commit(GET_POLL_LIST_FAILURE)
  },
  
  getPoll({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getPoll(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_POLL_FAILURE);
            reject();
          }
          commit(GET_POLL_SUCCESS, {
            poll: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_POLL_FAILURE);
          reject();
        })
    })
  },
 
  
  updatePoll({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "question",
        "isActive"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updatePoll(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createPoll({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createPoll(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deletePoll({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deletePoll(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_POLL_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.poll));
  },
  [GET_POLL_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_POLL_LIST_SUCCESS](state, action) {
    state.list = action.pollList;
    state.listUpdated = new Date();
  },
  [GET_POLL_FAILURE](state) {
    state.selected = null
  },
  [GET_POLL_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.poll));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/poll.js